export const BEFORE_YOU_GO_ITEM_DESCRIPTION_MAX_CHARS = 150;

export function limitQuillPlainText(quill, maxLength) {
  if (!quill || !maxLength) return;
  const text = quill.getText() || "";
  const limitWithTrailingNewline = maxLength + 1;
  if (text.length <= limitWithTrailingNewline) return;
  const selection = quill.getSelection();
  quill.deleteText(maxLength, text.length - maxLength, "silent");
  if (selection) {
    quill.setSelection(Math.min(selection.index, maxLength), 0, "silent");
  }
}

export function getCountableTextFromQuill(quill) {
  if (!quill) return "";
  return (quill.getText() || "").replace(/\n$/, "");
}

export function preventQuillInputOverLimit(event, quill, maxLength) {
  if (!quill || !maxLength) return;
  if (event.ctrlKey || event.metaKey || event.altKey) return;
  const allowedControlKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "Tab",
    "Escape",
  ];
  if (allowedControlKeys.includes(event.key)) return;
  const isTextCharacter = event.key.length === 1;
  const isLineBreak = event.key === "Enter";
  if (!isTextCharacter && !isLineBreak) return;
  const selection = quill.getSelection();
  const selectedLength = selection?.length || 0;
  const currentLength = getCountableTextFromQuill(quill).length;
  if (currentLength - selectedLength + 1 > maxLength) {
    event.preventDefault();
  }
}

export function getCountableEditorTextFromHtml(html = "") {
  if (typeof document === "undefined") return "";
  const element = document.createElement("div");
  element.innerHTML = html || "";
  return (element.textContent || "").replace(/\n$/, "");
}
